import Dashboard from "components/Admin/Dashboard";
import AdminUsers from "components/Admin/Users/AdminUsers";
import Roles from "components/Admin/Roles/RolesList";
import Permissions from "components/Admin/Permissions/PermissionsList";
import dashboardIcon from "assets/img/dashboard.svg";
import userlIcon from "assets/img/user.svg";
import ModulePermissions from "../components/Admin/Module/ModulePermissions";
//Zab
import BrandsList from "../components/Admin/Brands/BrandsList";
import OrderDetail from "../components/Admin/Order/OrderDetails";
import List from "../components/Admin/Lists/List";
import ListType from "../components/Admin/Lists/ListType";
import BrandWizard from "../components/Admin/Brands/BrandWizard";
import BrandData from "../components/Admin/Brands/BrandData";
import AddCustomer from "../components/Admin/Customers/AddCustomer";
import CustomerList from "../components/Admin/Customers/CustomerList";
import UserProfile from "../components/Admin/Users/UserProfile";
import CustomerPermission from "../components/Admin/Customers/CustomerPermission";
import BrandDataDefinitions from "../components/Admin/Brands/BrandDataDefinitions";
import ShippingOptions from "../components/Admin/Customers/ShippingOptions";
import ContactList from "../components/Admin/Contacts/ContactList";
//import UsersList from "../components/Admin/Customers/UsersList";
import EditCustomer from "../components/Admin/Customers/EditCustomer";
import TagLayouts from "../components/Admin/Brands/TagLayouts";
import BrandAddressList from "../components/Admin/Addresses/AddressList";
import BrandUsersList from "../components/Admin/Users/UsersList";
import TransformationRules from "../components/Admin/Brands/TransformationRules";
import LookupCSV from "../components/Admin/Brands/Lookup Definition/LookupCSV";
import LookupListing from "../components/Admin/Brands/Lookup Definition/LookupListing";
import LookupJSON from "../components/Admin/Brands/Lookup Definition/LookupJSON";
import AddBrand from "../components/Admin/Brands/AddBrand";
import OrderList from "../components/Admin/Order/OrderList";
import CartsList from "../components/Admin/Order/CartsList";
import CreateOrder from "../components/Admin/Order/CreateOrder";
import CheckoutCart from "../components/Admin/Order/CheckoutCart";
import ViewCart from "../components/Admin/Order/ViewCart";
import APIToken from "../components/Admin/Brands/APIToken";
import ChangePassword from "../components/Admin/ChangePassword";
import TransformationRulesForm from "../components/Admin/Brands/TransformationRulesForm";
import BrandErrorMessagesListing from "../components/Admin/DataSync/SyncError/BrandErrorMessagesListing";
import ErrorsListing from "../components/Admin/DataSync/SyncError/ErrorsListing";
import Test from "../components/Admin/Test";
import ConfigurationSettings from "../components/Admin/Settings/ConfigurationSettings";

var dashboardRoutes = [
    {
        path: "/Admin/profile",
        name: "Profile",
        icon: "pe-7s-graph",
        component: UserProfile,
        iconImagePath: dashboardIcon,
        permission: "edit-profile"
    },
    {
        path: "/Admin/dashboard",
        name: "Dashboard",
        icon: "pe-7s-graph",
        component: Dashboard,
        iconImagePath: dashboardIcon,
        permission: "admin-dashboard"
    },
    {
        path: "/Admin/users",
        name: "Users",
        icon: "pe-7s-users",
        iconImagePath: userlIcon,
        component: AdminUsers,
        permission: "user-edit"
    },
    {
        path: "/Admin/:model/:id/users",
        name: "Brand Users",
        icon: "pe-7s-users",
        iconImagePath: userlIcon,
        component: BrandUsersList,
        permission: "user-edit"
    },
    {
        path: "/Admin/roles",
        name: "Roles",
        icon: "pe-7s-users",
        iconImagePath: userlIcon,
        component: Roles,
        permission: "role-edit"
    },
    {
        path: "/Admin/modules/:id?",
        name: "Modules",
        icon: "pe-7s-users",
        iconImagePath: userlIcon,
        component: ModulePermissions,
        permission: "role-edit"
    },
    {
        path: "/Admin/permissions",
        name: "Permissions",
        icon: "pe-7s-users",
        iconImagePath: userlIcon,
        component: Permissions,
        permission: "permission-edit"
    },
    {
        path: "/Admin/manage-lists/:compName/:parentName?",
        name: "List",
        component: List,
        permission: "manage-lists"
        // exactPro: false,
    },
    {
        path: "/Admin/manage-lists",
        name: "Manage Lists",
        component: ListType,
        exactPro: false,
        permission: "manage-lists"
    },
    {
        path: "/Admin/brands-list",
        name: "Brands List",
        component: BrandsList,
        exactPro: false,
        permission: "brands-list"
    },
    {
        path: "/Admin/brand-wizard",
        name: "Brands Wizard",
        component: BrandWizard,
        exactPro: false,
        permission: "data-definitions"
    },
    {
        path: "/Admin/order-detail/:id",
        name: "Order Detail",
        component: OrderDetail,
        exactPro: false,
        permission: "view-order-detail"
    },
    {
        path: "/Admin/brand-data/:brandId",
        name: "Brand Data",
        component: BrandData,
        exactPro: false,
        permission: "view-and-download-brand-products-styles"
    },
    {
        path: "/Admin/add-customer",
        name: "Add Customer",
        component: AddCustomer,
        exactPro: false,
        permission: "add-customer"
    },
    {
        path: "/Admin/:id/customer-edit",
        name: "Edit Customer",
        icon: "pe-7s-user",
        iconImagePath: userlIcon,
        component: EditCustomer,
        permission: "customer-edit"
    },
    {
        path: "/Admin/:id/customer-permissions",
        name: "Manage Permissions",
        component: CustomerPermission,
        permission: 'customer-edit',
    },
    {
        path: "/Admin/customers/:id/shipping-options",
        name: "Manage Shipping Options",
        component: ShippingOptions,
        permission: 'customer-can-manage-shipping-options',
    },
    {
        path: "/Admin/:model/:id/addresses",
        name: "Manage Addresses",
        component: BrandAddressList,
        permission: 'manageaddresses',
    },
    {
        path: "/Admin/:model/:id/contacts",
        name: "Manage Contacts",
        component: ContactList,
        permission: 'manage-contacts',
    },
    {
        path: "/Admin/customer/:id/users",
        name: "Manage Users",
        component: BrandUsersList,
        permission: 'customer-can-manage-users',
    },
    {
        path: "/Admin/brand/:id/tag-layouts",
        name: "Tag Layouts",
        component: TagLayouts,
        permission: 'manage-brand-tag-layouts',
    },
    {
        path: "/Admin/customers",
        name: "Customers",
        component: CustomerList,
        exactPro: false,
        permission: 'customer-users',
    },
    {
        path: "/Admin/brand/:brandId/data-definitions",
        name: "Brand Data Definitions",
        component: BrandDataDefinitions,
        exactPro: false,
        permission: 'data-definitions',
    },
    {
        path: "/Admin/brand/:data_definition_id/transformation-rules",
        name: "Brand Transformation Rules",
        component: TransformationRules,
        exactPro: false,
        permission: 'transformation-rules'
    },
    {
        path: "/Admin/brand/:brandId/add-lookup-table",
        name: "Lookup Data Definitions",
        component: LookupCSV,
        exactPro: false,
        permission: 'manage-brand-lookup-tabeles',
    },
    {
        path: "/Admin/brand/:brandId/lookup-listing",
        name: "Lookup Listing",
        component: LookupListing,
        exactPro: false,
        permission: 'lookup-definitions',
    },
    {
        path: "/Admin/order-list",
        name: "Order Listing",
        component: OrderList,
        permission: 'order-list',
    },
    {
        path: "/Admin/open-carts",
        name: "Open Carts",
        component: CartsList,
        permission: 'open-carts',
    },
    {
        path: "/Admin/create-order",
        name: "Create Order",
        component: CreateOrder,
        permission: 'order-management',
    },
    {
        path: "/Admin/cart/:cart_id/checkout",
        name: "Checkout Cart",
        component: CheckoutCart,
        permission: 'customer-can-checkout-cart',
    },
    {
        path: "/Admin/cart/:cart_id/view",
        name: "View Cart",
        component: ViewCart,
        permission: 'open-carts',
    },
    {
        path: "/Admin/brand/:brandId/edit",
        name: "Edit Brand",
        component: AddBrand,
        exactPro: false,
        permission: 'create-edit-brand'
    },
    {
        path: "/Admin/brand/:definitionId/transformation-rules/edit",
        name: "Transformation rules edit",
        component: TransformationRules,
        exactPro: false,
        permission: 'transformation-rules'
    },
    {
        path: "/Admin/brand/transformation-rules/addRule",
        name: "Transformation rules edit",
        component: TransformationRulesForm,
        exactPro: false,
        permission: 'transformation-rules'
    },
    {
        path: "/Admin/order/:brandId/create",
        name: "Create Order",
        component: CreateOrder,
        exactPro: false,
        permission: 'create-edit-brand'
    },
    {
        path: "/Admin/brand/:definitionId/api_view",
        name: "API Token",
        component: APIToken,
        exactPro: false,
        permission: 'edit-configuration-settings',
    },
    {
        path: "/Admin/changePassword",
        name: "API Token",
        component: ChangePassword,
        exactPro: false,
        permission: "edit-profile"
    },
    {
        path: "/Admin/configuration-settings",
        name: "Configure Settings",
        component: ConfigurationSettings,
        exactPro: false,
        permission: 'configuration-settings'
    },
    {
        path: "/Admin/brands/syncErrors/:brand_id",
        name: "Brand Errors",
        component: ErrorsListing,
        exactPro: false,
        permission: 'brand-errors-list'
    },
    {
        path: "/Admin/brand/:errorId/BrandErrorMessages",
        name: "Brand Errors",
        component: BrandErrorMessagesListing,
        exactPro: false,
        permission: 'brand-errors-list'
    },
    {
        path: "/Admin/brand/product-styles",
        name: "Brand Data",
        component: BrandData,
        exactPro: false,
        permission: 'brand-errors-list'
    },
    {
        path: "/Admin/test",
        name: "Test",
        component: Test,
        exactPro: false
    },
    {
        redirect: true,
        path: "/Admin",
        to: "/Admin/dashboard",
        name: "Dashboard"
    }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx